import { render, staticRenderFns } from "./AppUpdate.vue?vue&type=template&id=2b008521&scoped=true&"
import script from "./AppUpdate.vue?vue&type=script&lang=js&"
export * from "./AppUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdate.vue?vue&type=style&index=0&id=2b008521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b008521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VLayout,VProgressCircular})
